import React, { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle, ExternalLink, CheckCheck, Inbox } from "lucide-react";

export default function MensagensWhatsApp() {
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/whatsapp/mensagens")
      .then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);
  useEffect(load, [load]);

  const marcarLida = async (m) => {
    try {
      await api.post(`/whatsapp/mensagens/${m.id}/lida`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const fmtTel = (t) => {
    const d = (t || "").replace(/^55/, "");
    return d.length === 11 ? `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}` : d;
  };

  return (
    <div className="space-y-6" data-testid="mensagens-whatsapp-page">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-aj-orange">Comunicação</div>
          <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-aj-blue-deep mt-1">Respostas WhatsApp</h1>
          <p className="text-sm text-aj-text-muted mt-1 max-w-2xl">
            Mensagens que os clientes respondem ao número oficial MontaJá, vinculadas automaticamente à OS pelo telefone.
          </p>
        </div>
        {data && (
          <div className="aj-card px-5 py-3 border-l-4 border-l-[#FF6700]" data-testid="msgs-nao-lidas">
            <div className="text-[10px] font-bold uppercase tracking-wider text-aj-text-muted">Não lidas</div>
            <div className="font-display font-extrabold text-2xl text-aj-blue-deep">{data.nao_lidas}</div>
          </div>
        )}
      </div>

      <div className="space-y-3">
        {data?.mensagens.length === 0 && (
          <div className="aj-card p-10 text-center text-aj-text-muted" data-testid="msgs-vazio">
            <Inbox className="w-8 h-8 mx-auto mb-2 opacity-40" />
            Nenhuma resposta recebida ainda. Quando um cliente responder no WhatsApp, aparecerá aqui.
          </div>
        )}
        {data?.mensagens.map((m) => (
          <div key={m.id}
            className={`aj-card p-4 sm:p-5 ${!m.lida ? "border-l-4 border-l-[#FF6700]" : ""}`}
            data-testid={`msg-card-${m.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-display font-bold text-aj-blue-deep">
                    {m.cliente_nome || m.nome_contato || fmtTel(m.telefone)}
                  </span>
                  {m.os_numero && (
                    <span className="px-2 py-0.5 rounded-md bg-aj-surface-2 text-[10px] font-bold text-aj-blue-deep">
                      OS {m.os_numero}
                    </span>
                  )}
                  {!m.lida && (
                    <span className="px-2 py-0.5 rounded-md bg-aj-amber-soft text-[10px] font-bold uppercase text-aj-orange-hover">
                      Nova
                    </span>
                  )}
                </div>
                <div className="text-xs text-aj-text-muted mt-0.5">
                  {fmtTel(m.telefone)} · {new Date(m.recebida_em).toLocaleString("pt-BR")}
                </div>
                <p className="text-sm text-aj-text mt-2 whitespace-pre-wrap break-words">{m.mensagem}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <a href={`https://wa.me/${m.telefone}`} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs font-bold text-white bg-[#25D366] hover:opacity-90 px-3 py-2 rounded-lg transition-opacity"
                  data-testid={`msg-responder-${m.id}`}>
                  <MessageCircle size={13} /> Responder
                </a>
                {m.servico_id && (
                  <a href={`/admin/servicos/${m.servico_id}`}
                    className="inline-flex items-center gap-1.5 text-xs font-semibold text-aj-blue-deep hover:text-aj-orange px-2 py-2 transition-colors"
                    data-testid={`msg-ver-os-${m.id}`}>
                    <ExternalLink size={13} /> Ver OS
                  </a>
                )}
                {!m.lida && (
                  <button onClick={() => marcarLida(m)}
                    className="inline-flex items-center gap-1.5 text-xs font-semibold text-aj-text-muted hover:text-aj-blue-deep px-2 py-2 transition-colors"
                    data-testid={`msg-lida-${m.id}`}>
                    <CheckCheck size={14} /> Lida
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
